import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function LanguageSwitcher({ variant = 'default' }) {
  const { lang, setLang } = useLanguage();

  const isVi = lang === 'vi';

  if (variant === 'login') {
    return (
      <button
        data-testid="lang-switcher-login"
        onClick={() => setLang(isVi ? 'en' : 'vi')}
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-border hover:border-tertiary/40 bg-surface transition-all duration-200 text-xs font-body font-medium text-text-secondary hover:text-text-primary"
      >
        <span className={`${!isVi ? 'text-primary font-semibold' : 'text-text-secondary'}`}>EN</span>
        <span className="text-border">|</span>
        <span className={`${isVi ? 'text-primary font-semibold' : 'text-text-secondary'}`}>VI</span>
      </button>
    );
  }

  return (
    <button
      data-testid="lang-switcher"
      onClick={() => setLang(isVi ? 'en' : 'vi')}
      className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg border border-border hover:border-tertiary/40 bg-background transition-all duration-200 text-xs font-body font-medium"
      title={isVi ? 'Switch to English' : 'Chuyển sang Tiếng Việt'}
    >
      <span className={`transition-colors ${!isVi ? 'text-primary font-semibold' : 'text-text-secondary'}`}>EN</span>
      <span className="text-border">/</span>
      <span className={`transition-colors ${isVi ? 'text-primary font-semibold' : 'text-text-secondary'}`}>VI</span>
    </button>
  );
}
